import type { AxiosInstance } from 'axios'
import type { ApiRequestConfig } from './types'

export class ApiBase {
  constructor(protected api: AxiosInstance) {}

  /**
   * axios 1.19 起回傳型別為條件型別 AxiosResponseResult，
   * 泛型 R 未綁定時 TS 無法化簡，故需明確斷言為 Promise<R>。
   * 實際回傳值由 response interceptor 決定（完整的 AxiosResponse）。
   */
  delete<R>(url: string, config?: ApiRequestConfig): Promise<R> {
    return this.api.delete(url, config) as Promise<R>
  }

  get<R>(url: string, config?: ApiRequestConfig): Promise<R> {
    return this.api.get(url, config) as Promise<R>
  }

  patch<R>(url: string, data: unknown, config?: ApiRequestConfig): Promise<R> {
    return this.api.patch(url, data, config) as Promise<R>
  }

  post<R>(url: string, data: unknown, config?: ApiRequestConfig): Promise<R> {
    return this.api.post(url, data, config) as Promise<R>
  }

  put<R>(url: string, data: unknown, config?: ApiRequestConfig): Promise<R> {
    return this.api.put(url, data, config) as Promise<R>
  }
}
